import React, { useCallback, useState } from 'react';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import styles from './index.less';
import PasteSpecialMenu from './paste-special-menu';
import { PasteSpecialType, IPasteSpecialProps } from './interface';
import { CopyElementType, ICopyInfo } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import PasteSpecial from '@src/slide/application/service/copy-paste/core/paste/paste-special/paste-special-strategy';
import PasteDestinationTheme from '@src/slide/application/service/copy-paste/core/paste/paste-special/paste-special-strategy/paste-destination-theme';
import PasteSourceFormat from '@src/slide/application/service/copy-paste/core/paste/paste-special/paste-special-strategy/paste-source-format';
import classNames from 'classnames';
import PasteText from '@src/slide/application/service/copy-paste/core/paste/paste-special/paste-special-strategy/paste-text';

/**
 * 选择性粘贴面板 图标按钮+菜单
 */
const PasteSpecialPanel = (props: IPasteSpecialProps) => {
    const [isMenuVisible, setMenuVisible] = useState(false);
    // 应用不同粘贴策略
    const doPasteSpecial = (type: PasteSpecialType, copyInfo: ICopyInfo) => {
        const pasteSpecial = new PasteSpecial();
        const strategyMap = {
            [PasteSpecialType.DESTINATION_THEME]: new PasteDestinationTheme(copyInfo, props.serviceDelegates),
            [PasteSpecialType.SOURCE_FORMAT]: new PasteSourceFormat(copyInfo, props.serviceDelegates),
            [PasteSpecialType.TEXT_ONLY]: new PasteText(copyInfo, props.serviceDelegates),
        };
        pasteSpecial.setStrategy(strategyMap[type]);
        pasteSpecial.executePaste();
    };

    // 点击选择性粘贴菜单
    const handleMenuClick = useCallback(
        (menuId) => {
            props.beforePaste?.();
            doPasteSpecial(menuId, props.copyInfo);
            props.afterPaste?.();
        },
        [props.copyInfo],
    );

    const handleVisibleChange = (visible) => {
        setMenuVisible(visible);
    };

    const getClassName = () => {
        let className = styles['paste-special-panel'];
        if (isMenuVisible) {
            className = classNames(className, styles['paste-special-panel-clicked']);
        }

        return className;
    };

    const handleMouseDown = (e) => {
        // 冒泡到上层后会清除选中态 canvas-base-presenter.ts
        // 需要在此处阻止冒泡
        e.stopPropagation();
    };

    return (
        <div
            id="paste-special-panel"
            className={getClassName()}
            style={{ left: props.position.left, top: props.position.top }}
            onMouseDown={handleMouseDown}
        >
            <Dropdown
                dropContent={(
                    <PasteSpecialMenu
                        onMenuClick={handleMenuClick}
                        showTextOnlyOption={props.copyInfo.type === CopyElementType.TEXT}
                    />
                )}
                alignment="left"
                destroyOnClose={false}
                onVisibleChange={handleVisibleChange}
            >
                <div className={styles['btn-wrapper']}>
                    <div className={styles.file}></div>
                    <div className={styles.arrow}></div>
                </div>
            </Dropdown>
        </div>
    );
};

export default React.memo(PasteSpecialPanel);
